import { BASIC_REG_CONFIG } from './configs/basic';
import { DARK_REG_SPORTS_CONFIG } from './configs/dark-sports';
import { DARKLE_REG_CONFIG } from './configs/darkle';
import { DARKLE_REG_GAMES_CONFIG } from './configs/darkle-games';
import { DARKLE_REG_PROVIDERS_CONFIG } from './configs/darkle-providers';
import { GOLD_BTN_REG_CONFIG } from './configs/gold-btn';
import { GREEN_BTN_REG_CONFIG } from './configs/green-btn';
import { JUICYLVL_REG_CONFIG } from './configs/juicylvl';
import { LIGHTLE_CONFIG } from './configs/lightle';
import type { RegistrationConfig } from './types';

export const REGISTRATION_CONFIGS: Record<string, RegistrationConfig> = {
  darkle: DARKLE_REG_CONFIG,
  default: BASIC_REG_CONFIG,
  sandGoldBtn: GOLD_BTN_REG_CONFIG,
  secondaryGreenGradientBtn: GREEN_BTN_REG_CONFIG,
  juicylvl: JUICYLVL_REG_CONFIG,
  lightle: LIGHTLE_CONFIG,
  darkleProviders: DARKLE_REG_PROVIDERS_CONFIG,
  darkleGames: DARKLE_REG_GAMES_CONFIG,
  darkSports: DARK_REG_SPORTS_CONFIG,
};
